import { FC } from 'react'
import { useQuery } from '@apollo/client'

import Banner from 'components/navigation/banner'
import { EVENT } from 'routes/paths'
import { GetVenueAuctionsQuery } from 'gql'
import { formatAuctionEndDate, getImageUrl } from '~utils'
import { GET_VENUE_AUCTIONS } from 'gql/artwork/queries'

type FeaturedAuctionsProps = {
  venueSlug: string
}

const AuctionsBanner: FC<FeaturedAuctionsProps> = ({ venueSlug }) => {
  const { data } = useQuery<GetVenueAuctionsQuery>(GET_VENUE_AUCTIONS, {
    variables: {
      venueSlug,
    },
    notifyOnNetworkStatusChange: true,
  })
  const auctions = data?.allArtworks.edges.map(({ node }) => node) || []
  const items =
    auctions?.map(
      ({
        title,
        artworkOrTourOrArtistImage,
        description,
        currentBid,
        startingBid,
        slug,
        endDate,
        venue,
      }) => ({
        imageUrl: getImageUrl(
          artworkOrTourOrArtistImage,
          auctions?.length > 2 ? 256 : 640,
          auctions?.length > 2 ? 256 : 280
        ),
        title,
        description,
        fields: [
          [{ text: formatAuctionEndDate(endDate, venue?.timeZone) }],
          [{ text: `Current Bid: $${currentBid || startingBid || 'XXXX'}` }],
        ],
        link: EVENT(slug),
      })
    ) || []

  return items.length ? <Banner items={items || []} title={items?.length && 'Lots'} /> : null
}

export default AuctionsBanner
